// Import React
import React from "react";

// Navbar component (always visible on top)
function Navbar() {
  return (
    // Navbar with dark background to match footer
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        {/* Brand name */}
        <a className="navbar-brand" href="">
          Quiz App
        </a>

        {/* Hamburger menu button for smaller screens */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

       
      </div>
    </nav>
  );
}

// Export Navbar component
export default Navbar;
